import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { Box, Grid, styled } from '@mui/material'
import { Button } from '@carto/meridian-ds/components'
import { useNavigate } from 'react-router'
import IconFileUpload from 'assets/icons/icon-file-file-upload.svg?react'
import HomeDatasetsCard from './HomeDatasetsCard'
import { Dataset } from 'features/connections/types'

const ImportButton = styled(Button)(({ theme }) => ({
  width: '100%',
  height: '100%',
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.grey[50],
  border: `1px solid ${theme.palette.divider}`,
  maxWidth: 'unset',

  '& svg path': {
    fill: theme.palette.text.secondary
  }
}))

export function HomeDatasetsContent({
  datasets,
  withImportButton = true,
  maxDatasets
}: {
  datasets: Dataset[]
  withImportButton?: boolean
  maxDatasets?: number
}) {
  const navigate = useNavigate()
  const recentDatasets = useMemo(() => {
    if (maxDatasets) {
      return datasets.slice(0, maxDatasets)
    }
    return datasets
  }, [datasets, maxDatasets])

  const navigateToDataImport = () => {
    navigate('/data', { state: { import: true } })
  }

  return (
    <Box>
      <Grid container spacing={3}>
        {recentDatasets.map((dataset, i) => (
          <Grid item xs={6} md={4} lg={3} key={i}>
            <HomeDatasetsCard {...dataset} />
          </Grid>
        ))}
        {withImportButton && (
          <Grid item xs={6} md={4} lg={3}>
            <ImportButton
              color="inherit"
              startIcon={<IconFileUpload />}
              onClick={navigateToDataImport}
              variant="contained"
            >
              <FormattedMessage id="home.datasets.import" />
            </ImportButton>
          </Grid>
        )}
      </Grid>
    </Box>
  )
}

export default HomeDatasetsContent
